const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const getWindowOrigin = () => {
    if (typeof window === 'undefined') return '';
    return window.location.origin;
};

const stripApiSuffix = (value: string) => trimTrailingSlash(value).replace(/\/api$/, '');

export const API_BASE = (() => {
    const configured = process.env.REACT_APP_API_URL?.trim();
    if (configured) return trimTrailingSlash(configured);
    const origin = getWindowOrigin();
    return origin ? `${origin}/api` : '/api';
})();

export const PUBLIC_API_BASE_URL = (() => {
    const configured = process.env.REACT_APP_PUBLIC_API_BASE_URL?.trim();
    if (configured) return trimTrailingSlash(configured);
    const apiBase = process.env.REACT_APP_API_URL?.trim();
    if (apiBase) return stripApiSuffix(apiBase);
    return getWindowOrigin();
})();

export const getWebhookEndpoint = (workflowId: string) => {
    const base = PUBLIC_API_BASE_URL || getWindowOrigin();
    return `${trimTrailingSlash(base)}/api/webhooks/${workflowId}`;
};

export const getWebhookEndpointTemplate = () => {
    const base = PUBLIC_API_BASE_URL || getWindowOrigin();
    return `${trimTrailingSlash(base)}/api/webhooks/{workflowId}`;
};